<template>
  <div>
    <AppLayout>
      <Loader :visible="loading" />
      <router-view />
    </AppLayout>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import Loader from '../components/Loader';

export default {
  name: 'App',
  components: {
    Loader
  },
  data() {
    return {
      loading: false    
    }
  },
  created() {
    this.$root.$on('showLoader', this.showLoader);
    this.$root.$on('hideLoader', this.hideLoader);
    this.showEventTutorial();
  },
  methods: {
    ...mapActions('Web', ['showEventTutorial']),
    showLoader() {
      this.loading = true
    },
    hideLoader() {
      this.loading = false
    }
  }
}
</script>

<style>
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
